module.exports = __webpack_public_path__ + "static/media/skf.af24a6fc.png";